import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './permission' // 权限控制
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './components/registerCom'

Vue.use(ElementUI)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
